import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "../../Base";

export type MatchCompaniesPayload = {
  companyId: number;
  clientCompanyPrincipalId: number;
};

export type MatchProductsPayload = {
  associationId: number;
  productPrincipalId: number;
};

export enum PofileAssociationMixinTags {
  GetDistinctCompanies = "get_distinct_companies",
  MatchCompanies = "match_companies",
  IgnoreCompany = "ignore_company",
  GetAssociationsByProducts = "get_associations_by_products",
  IgnoreProduct = "ignore_product",
  MatchProducts = "match_products",
}

@Component
export default class ProfileAssociationMixin extends Base {
  getDistinctCompanies(slug: string, params?: any) {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT +
      `/${slug}/agents/match_by_product/profiles_association/by_companies.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: PofileAssociationMixinTags.GetDistinctCompanies,
      url: url,
      method: "GET",
    });
  }

  getAssociationsByProducts(slug: string, params?: any) {
    const queryString = this.paramsToQueryString(params);
    const url =
      API_ENDPOINT +
      `/${slug}/agents/match_by_product/profiles_association/by_products.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: PofileAssociationMixinTags.GetAssociationsByProducts,
      url: url,
      method: "GET",
    });
  }

  matchCompanies(slug: string, payload: MatchCompaniesPayload[]) {
    const url =
      API_ENDPOINT +
      `/${slug}/agents/match_by_product/profiles_association/match_companies.json`;

    const data = { companiesMatches: payload };

    return this.$store.dispatch("http/request", {
      tag: PofileAssociationMixinTags.MatchCompanies,
      url: url,
      method: "PUT",
      data,
    });
  }

  ignoreCompany(slug: string, companyId: string | number) {
    const url =
      API_ENDPOINT +
      `/${slug}/agents/match_by_product/profiles_association/ignore_company.json`;

    const data = { companyId };

    return this.$store.dispatch("http/request", {
      tag: PofileAssociationMixinTags.IgnoreCompany,
      url: url,
      method: "PUT",
      data,
    });
  }

  ignoreProduct(slug: string, associationId: string | number) {
    const url =
      API_ENDPOINT +
      `/${slug}/agents/match_by_product/profiles_association/ignore_product.json`;

    const data = { associationId };

    return this.$store.dispatch("http/request", {
      tag: PofileAssociationMixinTags.IgnoreProduct,
      url: url,
      method: "PUT",
      data,
    });
  }

  matchProducts(slug: string, payload: MatchProductsPayload[]) {
    const url =
      API_ENDPOINT +
      `/${slug}/agents/match_by_product/profiles_association/match_products.json`;

    const data = { matches: payload };

    return this.$store.dispatch("http/request", {
      tag: PofileAssociationMixinTags.MatchProducts,
      url: url,
      method: "PUT",
      data,
    });
  }
}
